// src/hooks/useAuctionSocket.ts
import { useCallback, useEffect } from 'react';
import { connectSocket, SOCKET_EVENTS } from '../utilities/socket';

const useAuctionWsHook = (auction_id: number, token?: string | null, callback?: any) => {
  const refreshAuctionData = useCallback(() => {
    if (typeof callback === 'function') {
      callback();
    }
  }, [callback]);

  useEffect(() => {
    if (!auction_id || !token)
      return () => {
        // no cleanup needed
      };

    // init socket with token
    const socket = connectSocket(token);

    if (!socket) {
      // console.warn('Socket socket not initialized');
      return () => {
        // no cleanup needed
      };
    }

    // join room
    socket.emit(SOCKET_EVENTS.JOIN_AUCTION, { auction_id });

    // attach listener
    socket.on(SOCKET_EVENTS.AUCTION_BID_PLACE, refreshAuctionData);

    // Socket.io uses 'connect' event when connection established or re-established
    socket.on('connect', () => {
      // re-join to ensure we're in the room after a reconnect
      socket.emit(SOCKET_EVENTS.JOIN_AUCTION, { auction_id });
      // refetch snapshot to reconcile missed messages
      // refreshAuctionData();
    });

    // cleanup
    return (): void => {
      try {
        socket.emit(SOCKET_EVENTS.LEAVE_AUCTION, { auction_id });
        socket.off(SOCKET_EVENTS.AUCTION_BID_PLACE, refreshAuctionData);
        socket.off('connect'); // remove on connect handler above
      } catch (err) {
        // ignore
      }
    };
  }, [auction_id, token, refreshAuctionData]);
};

export default useAuctionWsHook;
